// https://github.com/segmentio/is-url/
import { imageExtensions } from 'core-components/helpers/image'

const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/
const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/

const ATTRIBUTE_WHITESPACES = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g
const SAFE_URL = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i

export function isUrl(string: string) {
  if (typeof string !== 'string') {
    return false
  }

  const match = string.match(protocolAndDomainRE)
  if (!match) {
    return false
  }

  const everythingAfterProtocol = match[1]
  if (!everythingAfterProtocol) {
    return false
  }

  return (
    localhostDomainRE.test(everythingAfterProtocol) ||
    nonLocalhostDomainRE.test(everythingAfterProtocol)
  )
}

export function isImageUrl(url: string) {
  if (!url || !isUrl(url)) return false
  const ext = new URL(url).pathname.split('.').pop()
  return ext ? imageExtensions.includes(ext) : false
}

/**
 * Returns a safe URL based on a given value.
 * A URL is considered safe if it is safe for the user (does not contain any malicious code).
 * If a URL is considered unsafe, a simple `"#"` is returned.
 *
 * Based on: https://github.com/ckeditor/ckeditor5/blob/bce8267e16fccb25448b4c68acc3bf54336aa087/packages/ckeditor5-link/src/utils.js#L63
 */
export function ensureSafeUrl(url: string) {
  const normalizedUrl = String(url).replace(ATTRIBUTE_WHITESPACES, '')
  return normalizedUrl.match(SAFE_URL) ? url : '#'
}

export function urlValidation(url: string): Promise<string> {
  return new Promise((res) => {
    if (isUrl(url)) {
      res('')
    } else {
      res('You should enter correct url address')
    }
  })
}
